import React from 'react';
import { FormatOptionLabelMeta } from 'react-select/src/Select';
import CategoryModel from '../../../../../models/v2/category/category.model';
import { SelectMenuOptionType } from '../../../../../models/v2/general/select.model';

export function categoryOption(option: SelectMenuOptionType, labelMeta?: FormatOptionLabelMeta<SelectMenuOptionType>) {
	const category: CategoryModel = option.data;

	if (!category) {
		return <div className='category-option'>{option.label}</div>;
	}

	// Check if this is being rendered in the dropdown menu or as selected value
	const isInDropdown = labelMeta && labelMeta.context === 'menu';

	// Get the depth level from the category data (calculated in helper)
	const level = (category as any).depth || 0;

	// For selected values, show simple format without indentation and branch
	if (!isInDropdown) {
		return (
			<span className='category-option__title'>
				{category.title}
				{!category.active && <span className='category-option__inactive'> (inactive)</span>}
			</span>
		);
	}

	// For dropdown options, show hierarchical format with indentation and branch
	return (
		<div className='category-option' style={{ paddingLeft: `${level * 20}px` }}>
			{level > 0 && <span className='category-option__branch'>└─ </span>}
			<span className='category-option__title'>
				{category.title}
				{!category.active && <span className='category-option__inactive'> (inactive)</span>}
			</span>
		</div>
	);
}
